/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Modal component
import MDModal from "components/MDModal";

function MDDeleteModal({ open, onClose, item, itemType, onDelete }) {
  const handleDelete = () => {
    onDelete(item);
    onClose();
  };

  return (
    <MDModal
      open={open}
      onClose={onClose}
      title="Confirmar Eliminación"
      size="sm"
    >
      <MDBox p={3} textAlign="center">
        {/* Icono de advertencia */}
        <MDBox mb={3}>
          <Icon
            sx={{
              fontSize: "4rem !important",
              color: "error.main"
            }}
          >
            warning
          </Icon>
        </MDBox>

        {/* Mensaje de confirmación */}
        <MDTypography variant="h5" color="text" mb={2}>
          ¿Estás seguro?
        </MDTypography>
        
        <MDTypography variant="body1" color="text" mb={1}>
          Estás a punto de eliminar el{itemType === "candidato" ? " " : " la "}{itemType}:
        </MDTypography>
        
        <MDTypography variant="h6" color="dark" mb={2}>
          &quot;{item?.nombre_completo || item?.nombre}&quot;
        </MDTypography>
        
        <MDTypography variant="body2" color="text" mb={3}>
          Esta acción no se puede deshacer.
        </MDTypography>

        {/* Botones */}
        <MDBox display="flex" justifyContent="center" gap={2}>
          <MDButton variant="outlined" color="secondary" onClick={onClose}>
            Cancelar
          </MDButton>
          <MDButton variant="gradient" color="error" onClick={handleDelete}>
            Sí, Eliminar
          </MDButton>
        </MDBox>
      </MDBox>
    </MDModal>
  );
}

// Typechecking props for the MDDeleteModal
MDDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object,
  itemType: PropTypes.string.isRequired, // 'candidato' or 'empresa'
  onDelete: PropTypes.func.isRequired,
};

export default MDDeleteModal; 